<template>
  <div class="right-body" ref="rightBo" id="remoteTask">
    <div class="remote-task-up">
      <div class="remote-name">
        <div class="remote-name-task">
          {{$t('language.common.btLink')}}
        </div>
      </div>
      <div class="create-task">
        <div class="task-icon-position">
          <div :data-title="$t('language.common.cleanList')" class="icon-util broom task-broom-position"
            @click="remoteCleanOpen()"></div>
          <div :data-title="$t('language.cloudExploer.reFresh')" class="icon-util refresh task-refreshe-position"
            @click="refresh()"></div>
        </div>
        <div class="create-describe">{{$t('language.remoteTask.createDescribe')}}</div>
        <div class="create-task-button" @click="linkTaskOpen()">
          <div class="plus create-task-icon"></div>
          <span class="create-task-text">{{$t('language.remoteTask.createTask')}}</span>
        </div>
      </div>
    </div>
    <div style="padding: 0 2%;">
      <div class="remote-task-table-head">
        <table border="0" cellpadding="0" cellspacing="0" id="tasktableBox-head">
          <thead>
            <tr class="table-th">
              <th class="first-td-style remote-pointer" @click="sortName()">
                <span>{{$t('language.common.fileName')}}</span>
                <span v-show="arrowShow == 'name'">
                  <i v-show="!nameSort" class="icon-util down-arrow"></i>
                  <i v-show="nameSort" class="icon-util up-arrow"></i>
                </span>
              </th>
              <th class="td-size remote-pointer" @click="sortSize()">
                <span class="">{{$t('language.common.size')}}</span>
                <span v-show="arrowShow == 'size'">
                  <i v-show="!sizeSort" class="icon-util down-arrow"></i>
                  <i v-show="sizeSort" class="icon-util up-arrow"></i>
                </span>
              </th>
              <th class="td-status remote-pointer" @click="sortStatus()">
                <span>{{$t('language.common.status')}}</span>
                <span v-show="arrowShow == 'status'">
                  <i v-show="!statusSort" class="icon-util down-arrow"></i>
                  <i v-show="statusSort" class="icon-util up-arrow"></i>
                </span>
              </th>
              <th class="td-options">
                <span>{{$t('language.common.operate')}}</span>
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
    <!-- 兼容谷歌内核浏览器 -->
    <div v-if="!isFirefox" class="remote-task-body">
      <div class="remote-task-table" v-loading="loading">
        <el-scrollbar wrap-class="none" wrap-style="overflow-x:hidden;" view-class="view-box" view-style="height:100%;"
          style='height:100%;'>
          <table border="0" cellpadding="0" cellspacing="0" id="tasktableBox">
            <tbody>
              <tr v-for="(item, index) in offlineTaskData" :key="index" class="table-tr" @mouseenter="hoverIndex=index"
                @mouseleave="hoverIndex=-1" :class="hoverIndex==index&& !isRuning(item.result)?'remote-tr-hover':''"
                :style="{backgroundColor:index % 2 == 0 ? '#f8fafb' : 'write' }">
                <div class="link-list-backgroud" v-if="isRuning(item.result)" :style="{width:item.percent+'%'}"></div>
                <!-- 名称 -->
                <td class="first-td share-first-td"> <span class="task-hover" @click.stop="toOffLineAimCatalog(item)"
                    :title="item.name">{{item.name}}</span></td>
                <!-- 大小 -->
                <td class="td-options" style="position: absolute;right:42.5%;">
                  <span v-if="item.filesize==undefined">{{$t('language.common.load')}}</span>
                  <span v-if="item.filesize <= 0" style="margin-left: 8px;">- - -</span>
                  <span v-if="item.filesize > 0">{{item.filesize|formatByte}}</span>
                </td>
                <!-- 解析失败状态（名字过长单独样式） -->
                <td v-if="item.result=='Failed to Parse'" style="width: 15%;" class="td-options status-not-hover"
                  :class="[cLanguageArr.includes($i18n.locale)?'ch-status':'not-ch-status']">
                  <div class="status-div" style="position: absolute;right:23% ;">
                    <span style="color: #6f7886;">{{$t('language.remoteTask.failedToParse')}}</span>
                  </div>
                </td>
                <!-- 其他状态 -->
                <td v-if="item.result!='Failed to Parse' " class="td-options status-not-hover"
                  :class="[cLanguageArr.includes($i18n.locale)?'ch-status':'not-ch-status']">
                  <div class="status-div" style="position: absolute;right: 40%">
                    <span v-show="item.result=='Success'">{{$t('language.common.success')}}</span>
                    <span v-show="item.result=='Partial Success'">
                      <span>{{$t('language.common.partialSuccess')}}</span>
                      <span v-if="hoverIndex==index" class="link-operate link-retry-position"
                        @click.stop="retryData(item)">{{$t('language.common.retryMin')}}</span>
                    </span>
                    <span v-show="item.result=='Error' || item.result=='Partial Success Show Fail'">
                      <span> {{$t('language.common.failure')}}</span>
                      <span v-if="hoverIndex==index" class="link-operate link-retry-position"
                        @click.stop="retryData(item)">{{$t('language.common.retryMin')}}</span>
                    </span>
                    <span class="td-status-run" v-show="isRuning(item.result)">
                      <span v-if="item.percent">{{item.percent+'%'}}</span>
                      <span v-if="!item.percent">{{$t('language.common.running')}}</span>
                      <span v-if="item.result == downloadSuspended" style="margin-left: 19px;/*no*/"
                        class="link-retry-position noSeeds">{{$t('language.remoteTask.noSeeds')}}</span>
                    </span>
                    <span v-show="item.result=='Waiting' || item.result=='Waiting'+resultProtect">
                      <span>{{$t('language.common.waiting')}}</span>
                      <span v-if="hoverIndex==index && !vip" class="link-operate link-retry-position"
                        @click.stop="showPay()">{{$t('language.remoteTask.excuteNow')}}</span>
                    </span>
                  </div>
                </td>
                <!-- 按钮 -->
                <td class="td-options " style="position: absolute;right:0.5%;width: 12%;">
                  <span v-show="hoverIndex==index && !isRuning(item.result)">
                    <span class="link-operate tag link-others"
                      @click.stop="copyLink(item,$event)">{{$t('language.common.link')}}</span>
                    <span class="link-operate" v-if="item.result=='Waiting'"
                      @click="deleteOffLineTask(index,item)">{{$t('language.common.cancel')}}</span>
                    <span class="link-operate" v-else
                      @click="deleteOffLineTask(index,item)">{{$t('language.common.clean')}}</span>
                  </span>
                  <span v-show="isRuning(item.result)">
                    <span class="link-operate tag link-others"
                      @click.stop="copyLink(item,$event)">{{$t('language.common.link')}}</span>
                    <span class="link-operate" @click="cancel(index,item)">{{$t('language.common.cancel')}}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </el-scrollbar>
        <div v-if="emptyNoticeShow" class="remote-notice">{{$t('language.remoteTask.noRemote')}}</div>
      </div>
    </div>
    <!-- 兼容火狐内核浏览器 -->
    <div v-if="isFirefox" class="remote-task-body">
      <div class="remote-task-table" v-loading="loading" ref="remoteTaskTable">
        <el-scrollbar style='height:100%;'>
          <table border="0" cellpadding="0" cellspacing="0" id="tasktableBox"
            :style="{minHeight: this.firefoxTableHeight + 'px'}">
            <tbody>
              <tr v-for="(item, index) in offlineTaskData" :key="index" class="table-tr" @mouseenter="hoverIndex=index"
                @mouseleave="hoverIndex=-1" :class="hoverIndex==index&& !isRuning(item.result)?'remote-tr-hover':''"
                :style="{backgroundColor:index % 2 == 0 ? '#f8fafb' : 'write' }">
                <div class="link-list-backgroud" v-if="isRuning(item.result)" :style="{width:item.percent+'%'}"></div>
                <!-- 名称 -->
                <td class="first-td share-first-td"> <span class="task-hover" @click.stop="toOffLineAimCatalog(item)"
                    :title="item.name">{{item.name}}</span></td>
                <!-- 大小 -->
                <td class="td-options" style="position: absolute;right:42.5%;">
                  <span v-if="item.filesize==undefined">{{$t('language.common.load')}}</span>
                  <span v-if="item.filesize <= 0" style="margin-left: 8px;">- - -</span>
                  <span v-if="item.filesize > 0">{{item.filesize|formatByte}}</span>
                </td>
                <!-- 解析失败状态（名字过长单独样式） -->
                <td v-if="item.result=='Failed to Parse'" style="width: 15%;" class="td-options status-not-hover"
                  :class="[cLanguageArr.includes($i18n.locale)?'ch-status':'not-ch-status']">
                  <div class="status-div" style="position: absolute;right:38% ;">
                    <span style="color: #6f7886;">{{$t('language.remoteTask.failedToParse')}}</span>
                  </div>
                </td>
                <!-- 其他状态 -->
                <td v-if="item.result!='Failed to Parse' " class="td-options status-not-hover"
                  :class="[cLanguageArr.includes($i18n.locale)?'ch-status':'not-ch-status']">
                  <div class="status-div" style="position: absolute;right: 55%">
                    <span v-show="item.result=='Success'">{{$t('language.common.success')}}</span>
                    <span v-show="item.result=='Partial Success'">
                      <span>{{$t('language.common.partialSuccess')}}</span>
                      <span v-if="hoverIndex==index" class="link-operate link-retry-position"
                        @click.stop="retryData(item)">{{$t('language.common.retryMin')}}</span>
                    </span>
                    <span v-show="item.result=='Error' || item.result=='Partial Success Show Fail'">
                      <span> {{$t('language.common.failure')}}</span>
                      <span v-if="hoverIndex==index" class="link-operate link-retry-position"
                        @click.stop="retryData(item)">{{$t('language.common.retryMin')}}</span>
                    </span>
                    <span class="td-status-run" v-show="isRuning(item.result)">
                      <span v-if="item.percent">{{item.percent+'%'}}</span>
                      <span v-if="!item.percent">{{$t('language.common.running')}}</span>
                      <span v-if="item.result == downloadSuspended" style="margin-left: 19px;/*no*/"
                        class="link-retry-position">{{$t('language.remoteTask.noSeeds')}}</span>
                    </span>
                    <span v-show="item.result=='Waiting' || item.result=='Waiting'+resultProtect">
                      <span>{{$t('language.common.waiting')}}</span>
                      <span v-if="hoverIndex==index && !vip" class="link-operate link-retry-position"
                        @click.stop="showPay()">{{$t('language.remoteTask.excuteNow')}}</span>
                    </span>
                  </div>
                </td>
                <!-- 按钮 -->
                <td class="td-options " style="position: absolute;right:0.5%;width: 12%;">
                  <span v-show="hoverIndex==index && !isRuning(item.result)">
                    <span class="link-operate tag link-others"
                      @click.stop="copyLink(item,$event)">{{$t('language.common.link')}}</span>
                    <span class="link-operate" v-if="item.result=='Waiting'"
                      @click="deleteOffLineTask(index,item)">{{$t('language.common.cancel')}}</span>
                    <span class="link-operate" v-else
                      @click="deleteOffLineTask(index,item)">{{$t('language.common.clean')}}</span>
                  </span>
                  <span v-show="isRuning(item.result)">
                    <span class="link-operate tag link-others"
                      @click.stop="copyLink(item,$event)">{{$t('language.common.link')}}</span>
                    <span class="link-operate" @click="cancel(index,item)">{{$t('language.common.cancel')}}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </el-scrollbar>
        <div v-if="emptyNoticeShow" class="remote-notice">{{$t('language.remoteTask.noRemote')}}</div>
      </div>
    </div>
    <subfileSelectDialog ref="subfileSelectDialog"></subfileSelectDialog>
    <remoteTaskDialog ref="remoteTaskDialog"></remoteTaskDialog>
    <linkTaskDialog ref="linkTaskDialog"></linkTaskDialog>
    <uploadToTreeDialog ref="uploadToTreeDialog"></uploadToTreeDialog>
    <upgradeAccount ref="upgradeAccount"></upgradeAccount>
    <parseTipsDialog ref="parseTipsDialog"></parseTipsDialog>
    <taskCancelDialog ref="taskCancelDialog"></taskCancelDialog>
    <remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
  </div>
</template>

<script>
  import subfileSelectDialog from '@/components/popup/remote_task_popups/subfile_select_popup.vue';
  import taskListUtils from "@/js/workspace/task_list_util.js";
  import remoteTaskDialog from '@/components/popup/remote_task_popups/remote_task_clean_popup';
  import linkTaskDialog from '@/components/popup/remote_task_popups/add_link_task_popup';
  import uploadToTreeDialog from '@/components/popup/remote_task_popups/upload_to_tree_popup';
  import upgradeAccount from '@/components/popup/upgrade_popups/upgrade_account_popup';
  import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
  import parseTipsDialog from '@/components/popup/remote_task_popups/parse_tips';
  import commonUtils from "@/js/workspace/common_util.js";
  import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
  import taskOfflineUtils from '@/js/workspace/task_offline_util.js';
  import taskCancelDialog from '@/components/popup/remote_task_popups/task_cancel_popup.vue'
  import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";
  export default {
    data: function() {
      return {
        offlineTaskData: [],
        hoverIndex: -1,
        flag: true,
        running: false,
        pathJson: [],
        link: "",
        downloadSuspended: 'Download No Response',
        loading: false,
        interval: null,
        parseInterval: null,
        offline: 3,
        torrent: 5,
        arrowShow: null,
        sizeSort: false,
        statusSort: false,
        nameSort: true,
        remoteTaskShow: false,
        cLanguageArr: ['japanese', 'traditionalChinese', 'chinese'],
        emptyNoticeShow: false,
        tbodyHeight: 300,
        isFirefox: false,
        resultProtect: '.pro',
        vip: commonUtils.getUserToLocal().vip,
        firefoxTableHeight: 0
      }
    },
    components: {
      subfileSelectDialog,
      remoteTaskDialog,
      linkTaskDialog,
      uploadToTreeDialog,
      taskTransferUtils,
      upgradeAccount,
      parseTipsDialog,
      commonUtils,
      cloudExploerUtils,
      taskCancelDialog,
      remindBindEmailDialog
    },
    created() {
      // 初始化数据，优先从缓存中获取，缓存不存在则加载数据
      let that = this;
      let data = this.$store.state.remoteTaskArr;
      if (!data || data.length == 0) {
        this.loading = true;
        this.initData(function(offlineList) {
          that.offlineTaskData = offlineList;
          that.$store.commit("setRemoteTaskArr", offlineList);
          that.loading = false;
        });
      } else {
        this.offlineTaskData = data;
        this.offlineTaskData.sort(function(a, b) {
          return -(a.createTime - b.createTime)
        });
      }
      // 判断浏览器
      this.judgeBrowser();

    },
    mounted() {
      let that = this;
      // 如果有解析任务，轮询缓存中的结果
      this.parseInterval = setInterval(this.getMagnetParseResult(), 1000);
      this.parseInterval = setInterval(this.getMagnetParseResult, 1000);
      this.flushTasksIfPay();
      // 初始化火狐浏览器table高度
      this.$nextTick(function() {
        if (that.isFirefox) {
          that.firefoxTableHeight = that.$refs.remoteTaskTable.offsetHeight;
          var initHeightTimer = setInterval(function() {
            that.firefoxTableHeight = that.$refs.remoteTaskTable.offsetHeight;
            if (that.firefoxTableHeight > 0) {
              clearInterval(initHeightTimer);
              //console.log("init end")
            }
          }, 100);
        }
      });
    },
    beforeDestroy() {
      this.closeScheduled();
      clearInterval(this.parseInterval);
    },
    watch: {
      offlineTaskData(newValue, oldValue) {
        if (newValue.length > 0) {
          this.remoteTaskShow = true;
          this.openScheduled();
        } else {
          this.remoteTaskShow = false;
        }
      }
    },
    methods: {
      // 任务数据加载请求
      initData(callback) {
        var that = this;
        var list = [];
        var offLineData = new taskListUtils.taskListData(commonUtils.getUser().id, 3);
        this.Utils.doTasksRequest("list", offLineData).then(res => {
          if (res.status == 200) {
            var offlineTasks = res.tasks;
            offlineTasks.sort(function(a, b) {
              return -(a.createTime - b.createTime)
            });
            callback(offlineTasks);
          } else if (res.status == 401) {
            this.loading = false;
            that.$toast({
              text: that.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "remoteTask"
            });
          }
        }, err => {
          this.loading = false;
          that.$toast({
            text: err,
            type: 'fail',
            idValue: "remoteTask"
          });
        });
      },
      // 刷新功能
      refresh() {
        this.loading = true;
        this.arrowShow = null;
        var that = this;
        this.flushTasksIfPay();
        this.initData(function(offlineList) {
          that.offlineTaskData = offlineList;
          that.$store.commit("setRemoteTaskArr", that.offlineTaskData);
          that.openScheduled();
          setTimeout(function() {
            that.loading = false;
          }, 500)
        });
      },
      // 没有加载Loading效果的数据请求
      initDataNoLoad() {
        this.initData(function(offlineList) {
          that.offlineTaskData = offlineList;
          that.$store.commit("setRemoteTaskArr", offlineList);
        });
      },
      // 开启定时器
      openScheduled() {
        if (!this.running) {
          this.scheduled()
        }
      },
      // 关闭定时器
      closeScheduled() {
        if (this.running) {
          clearInterval(this.interval);
          this.running = false;
        }
      },
      // 进度定时器
      scheduled() {
        this.running = true;
        var that = this;
        this.getRunningProgress();
        this.interval = setInterval(function() {
          that.initData(function(offlineList) {
            if (offlineList) {
              that.changeResult(offlineList);
            }
            that.$store.commit("setRemoteTaskArr", that.offlineTaskData);
            if (that.getRunningProgress() == 0) {
              that.closeScheduled();
            }
          });
        }, 15000);
      },
      // 监控付费,刷新任务
      flushTasksIfPay() {
        var upgrade = this.$store.state.payUpgrade;
        if (upgrade) {
          var retryData={
            "ud": commonUtils.getUser().id
          }
          this.Utils.doTorrentRequest("flush", retryData).then(res => {
            // 重置
            that.$store.commit("setPayUpgrade", null);
          }, err => {
            this.$toast({
              text: err,
              type: 'fail',
              idValue: "remoteTask"
            });
          });
        }
      },
      getMagnetParseResult() {
        // 判断是否有磁力解析
        let status = this.$store.state.parseMagnet;
        if (status) {
          if (status == "Running") {
            this.$refs.parseTipsDialog.parseTipsShow = true;
          } else {
            clearInterval(this.parseInterval);
            let cloudSite = this.$store.state.parseMagnetCloudSite;
            let name = this.$store.state.parseMagnetName;
            this.$refs.linkTaskDialog.torrentResultHandler(status, cloudSite, name);
          }
        } else {
          clearInterval(this.parseInterval);
          this.$refs.parseTipsDialog.parseTipsShow = false;
        }
      },
      judgeBrowser() {
        var ua = window.navigator.userAgent;
        if (/Firefox/g.test(ua)) {
          this.isFirefox = true;
        }
      },
      // 获取正在执行的任务的进度，返回正在执行或等待的任务数量
      getRunningProgress() {
        let that = this;
        var count = 0;
        $.each(this.offlineTaskData, function(index, item) {
          if (item.result == "Waiting") {
            count++;
          }
          if (that.isRuning(item.result)) {
            count++;
            let url = item.url;
            if (url && url.indexOf("http") == 0) {
              that.getOffLineProgress(item);
            } else {
              that.getTorrentProgress(item);
            }
          }
        });
        return count;
      },
      // 链接复制功能
      copyLink(item, e) {
        this.link = item.url;
        this.copyActiveCode(e);
      },
      // 将后端任务数据和前端任务缓存数据做对比并更新。
      // 为了避免正在发送请求的任务状态被改变，本方法只改变状态不受保护的前端缓存任务。
      changeResult(realtimeList) {
        this.offlineTaskData.forEach(it => {
          realtimeList.forEach(task => {
            if (task.id == it.id) {
              if (it.filesize != task.filesize) {
                it.filesize = task.filesize;
              }
              if(it.name != task.name){
                it.name = task.name;
              }
              if (task.result != it.result && it.result.indexOf(this.resultProtect) == -1) {
                 if(it.result == 'Waiting'){
                   if(task.result == "Running"){
                     it.result = task.result;
                   }
                 }else{
                   it.result = task.result;
                 }
                this.refreshTraffic();
                this.refreshCloudDataList(it);
              }
            }
          })
        })
      },
      copyActiveCode(e) {
        const clipboard = new this.clipboard(e.target, {
          text: () => this.link
        });
        clipboard.on('success', e => {
          this.$toast({
            text: this.$t('language.remoteTask.successsExceed'),
            type: 'success',
            idValue: "tasktableBox"
          });
        })
        clipboard.on('error', e => {
          clipboard.off('error');
          clipboard.off('success');
        })
        clipboard.onClick(e);
      },
      isRuning(result) {
        return result == 'Running' || result == this.downloadSuspended
      },
      sortName() {
        this.arrowShow = "name";
        this.nameSort = !this.nameSort;
        var that = this;
        if (this.offlineTaskData) {
          this.offlineTaskData.sort(function(o, p) {
            if (that.nameSort) {
              return that.$refs.subfileSelectDialog.strCompare(o.name, p.name);
            } else {
              return that.$refs.subfileSelectDialog.strCompare(p.name, o.name);
            }
          });
        }
      },
      sortSize() {
        this.arrowShow = "size";
        this.sizeSort = !this.sizeSort;
        var that = this;
        if (this.offlineTaskData) {
          this.offlineTaskData.sort(function(o, p) {
            if (that.sizeSort) {
              return o.filesize - p.filesize;
            } else {
              return p.filesize - o.filesize;
            }
          });
        }
      },
      sortStatus() {
        this.arrowShow = "status";
        this.statusSort = !this.statusSort;
        var that = this;
        if (this.offlineTaskData) {
          this.offlineTaskData.sort(function(o, p) {
            let compare;
            if (that.isRuning(o.result) && !that.isRuning(p.result)) {
              compare = -1;
            } else if (!that.isRuning(o.result) && that.isRuning(p.result)) {
              compare = 1;
            } else if (that.isRuning(o.result) && that.isRuning(p.result)) {
              compare = parseFloat(o.percent) - parseFloat(p.percent)
            } else if (o.result == 'Waiting' && p.result != 'Waiting') {
              compare = -1;
            } else if (o.result != 'Waiting' && p.result == 'Waiting') {
              compare = 1;
            } else if (o.result == 'Waiting' && p.result == 'Waiting') {
              compare = parseFloat(o.createTime) - parseFloat(p.createTime)
            } else {
              compare = o.result.toUpperCase().charCodeAt(0) - p.result.toUpperCase().charCodeAt(0)
            }
            if (that.statusSort) {
              return compare;
            } else {
              return -compare;
            }
          });
        }
      },
      remoteCleanOpen() {
        this.$refs.remoteTaskDialog.remoteCleanShow = true;
      },
      showPay() {
        this.$refs.upgradeAccount.upgradeShow = true;
        this.$refs.upgradeAccount.remoteShow = true;
      },
      linkTaskOpen() {
        this.loading = false;
        if (!this.$refs.parseTipsDialog.parseTipsShow) {
          this.$refs.linkTaskDialog.linkTaskShow = true;
        }
      },
      toOffLineAimCatalog(item) {
        let aimData = item.toItem;
        if (this.flag) {
          let that = this;
          this.flag = false;
          let folderId = aimData.id;
          let fileName = aimData.name;
          let driveId = aimData.driveId;
          let pathData = this.$store.state.pathJson[folderId + driveId];
          this.encapsulationPath(aimData, pathData)
          this.flag = true;
          this.selectOption(aimData);
          this.$router.push({
            name: "cloudExploer",
            query: {
              cloudType: aimData.driveType,
              folderId: folderId,
              folderName: fileName,
              tokenId: driveId
            }
          });
        }
      },
      encapsulationPath(sourceAimData, pathData) {
        let that = this;
        if (!pathData) {
          for (let i = sourceAimData.nodes.length - 1; i >= 0; i--) {
            that.pathJson.push({
              id: sourceAimData.nodes[i].fileId,
              name: sourceAimData.nodes[i].fileName,
              driveId: sourceAimData.nodes[i].tokenId
            });
            let JsonList = Object.assign([], that.pathJson);
            that.$store.commit("setPathJson", {
              folderId: sourceAimData.nodes[i].fileId + sourceAimData.nodes[i].tokenId,
              json: JsonList
            });
          }
        }
      },
      selectOption(sourceData) {
        let dom;
        let rootDir;
        let that = this;
        $.each(that.$parent.$children, function(i, item) {
          if (item.menuOptions) {
            dom = that.$parent.$children[i];
            return;
          }
        });
        let clouds = dom.clouds;
        rootDir = sourceData.nodes[sourceData.nodes.length - 1];
        $.each(clouds, function(i, item) {
          if (rootDir.tokenId == item.id) {
            dom.driveOptionSelect(i);
          }
        });
      },
      deleteOffLineTask(index, item) {
        let that = this;
        if (item.type == this.offline) {
          let deleteData = {
            ud: commonUtils.getUser().id,
            id: item.id,
            type: this.offline
          }
          this.Utils.doTasksRequest("delete", deleteData).then(res => {
            this.cancelResposeHandler(res, index);
          }, err => {
            that.$toast({
              text: err,
              type: 'fail',
              idValue: "remoteTask"
            });
          });
        }
        if (item.type == this.torrent) {
          let deleteData = {
            ud: commonUtils.getUser().id,
            id: item.id,
            type: this.torrent
          }
          this.Utils.doTorrentRequest("delete", deleteData).then(res => {
            this.cancelResposeHandler(res, index);
          }, err => {
            that.$toast({
              text: err,
              type: 'fail',
              idValue: "remoteTask"
            });
          });
        }
      },
      retryData(item) {
        let retryData = {
          ud: commonUtils.getUser().id,
          id: item.id,
        }
        var oldState = item.result;
        if (item.type == this.offline) {
          retryData.type = this.offline;
          // 防止请求过程中被定时器更新状态
          item.result = "Waiting" + this.resultProtect;
          this.Utils.doTasksRequest("execute", retryData).then(res => {
            item.result = "Waiting";
            this.openScheduled();
            this.retryResult(res, item);
          }, err => {
            item.result = oldState;
            this.closeScheduled();
            this.$toast({
              text: err,
              type: 'fail',
              idValue: "remoteTask"
            });
          });
        }
        if (item.type == this.torrent) {
          retryData.type = this.torrent;
          // 防止请求过程中被定时器更新状态
          item.result = "Waiting" + this.resultProtect;
          this.Utils.doTorrentRequest("retry", retryData).then(res => {
            item.result = "Waiting";
            this.retryFrozen = false;
            this.openScheduled();
            this.retryResult(res, item);
          }, err => {
            item.result = oldState;
            this.closeScheduled();
            this.$toast({
              text: err,
              type: 'fail',
              idValue: "remoteTask"
            });
          });
        }
      },
      retryResult(res, item) {
        if (res.status == 400) {
          item.result = "Error"
          if (res.reason == 'TCDDWNF') {
            this.$toast({
              text: this.$t('language.remoteTask.undefinedDisk'),
              type: 'fail',
              idValue: "tasktableBox"
            });
          }
          if (res.reason == 'TTHRIL') {
            this.$toast({
              text: this.$t('language.exception.maxRunningLimit'),
              type: 'fail',
              idValue: "tasktableBox"
            });
          }
        }
        if (res.status == 401) {
          this.$toast({
            text: this.$t('language.exception.' + res.reason),
            type: 'fail',
            idValue: "remoteTask"
          });
        }
      },
      cancel(index, item) {
        this.$refs.taskCancelDialog.index = index;
        this.$refs.taskCancelDialog.item = item;
        this.$refs.taskCancelDialog.taskCancelShow = true;
      },
      cancelRunRemoteTask(index, item) {
        let that = this;
        let cancelData;
        // 取消离线任务
        if (item.type == this.offline) {
          var type = this.offline;
          cancelData = new taskListUtils.cancelIdData(commonUtils.getUser().id, type, item.id, item.id);
          this.Utils.doTasksRequest('cancel', cancelData).then(res => {
            that.$refs.taskCancelDialog.loading = false;
            this.cancelResposeHandler(res, index);

          }, err => {
            that.$refs.taskCancelDialog.loading = false;
            this.closeScheduled();
            that.$toast({
              text: err,
              type: 'fail',
              idValue: "remoteTask"
            });
          });
        }
        // 取消种子任务
        if (item.type == this.torrent) {
          cancelData = {
            "ud": commonUtils.getUser().id,
            "id": item.id,
            "totalSize": 0,
            "type": this.torrent
          };
          this.Utils.doTorrentRequest('cancel', cancelData).then(res => {
            that.$refs.taskCancelDialog.loading = false;
            this.cancelResposeHandler(res, index);
          }, err => {
            that.$refs.taskCancelDialog.loading = false;
            this.closeScheduled();
            that.$toast({
              text: err,
              type: 'fail',
              idValue: "remoteTask"
            });
          });
        }
      },
      refreshTraffic() {
        let that = this;
        let user = commonUtils.getUser();
        this.Utils.doUserHaveLoginRequest('get', {
          ud: user.id,
          salt: user.salt
        }).then(response => {
          user = response.user;
          that.$store.commit('setPassWord', response.user.password);
          delete user.password;
          commonUtils.setUserToLocal(user);
          if (that.$parent.$refs.rightContBan) {
            that.$parent.$refs.rightContBan.usedTraffic = user.usedBytes;
            that.$parent.$refs.rightContBan.totalTraffic = user.totalBytes;
          }
        });
      },
      cancelResposeHandler(res, index) {
        if (res.status == 200) {
          this.offlineTaskData.splice(index, 1);
          this.$store.commit("setRemoteTaskArr", this.offlineTaskData);
          this.$refs.taskCancelDialog.taskCancelShow = false;
        } else if (res.status == 401) {
          this.$toast({
            text: this.$t('language.exception.' + res.reason),
            type: 'fail',
            idValue: "remoteTask"
          });
        }
      },
      getTorrentProgress(item) {
        const requestData = new taskOfflineUtils.addTorrentTask(commonUtils.getUser().id,
          item.id, 0, [], {}, 0);
        const that = this;
        this.Utils.doTorrentRequest('progress', requestData).then(res => {
          if (res.status == 200) {
            if (item.percent) {
              let oldProgress = parseFloat(item.percent);
              let newProgress = parseFloat(res.data.progress);
              if (oldProgress < newProgress) {
                item.percent = res.data.progress;
              }
            } else {
              item.percent = res.data.progress;
            }
            that.updateDom();
          } else if (res.status == 401) {
            this.$toast({
              text: this.$t('language.exception.' + res.reason),
              type: 'fail',
              idValue: "remoteTask"
            });
          }
        }, err => {
          that.$toast({
            text: err,
            type: 'fail',
            idValue: "remoteTask"
          });
        });
      },
      refreshCloudDataList(item) {
        let toItem = item.toItem;
        let folderId = toItem.id;
        let driveId = toItem.driveId;
        let cloudType = toItem.driveType;
        // 刷新云盘缓存数据
        let listData = new cloudExploerUtils.filelistData(folderId, commonUtils.getUser().id, driveId);
        commonUtils.refreshTreeData(listData, cloudType, null, this.$parent.$refs.cloudExploer, function(res) {});
      },
      getOffLineProgress(item) {
        var that = this;
        let getData = {
          ud: commonUtils.getUser().id,
          id: item.id,
          type: this.offline,
        }
        this.Utils.doTasksRequest('get_progress', getData).then(res => {
          if (res.status == 200 && res.progress != 'TASK_CANCELED') {
            if (item.percent) {
              let oldProgress = parseFloat(item.percent);
              let newProgress = parseFloat(res.progress);
              if (oldProgress < newProgress) {
                item.percent = res.progress;
              }
            } else {
              item.percent = res.progress;
            }
            that.updateDom();
          }
        }, err => {
          that.$toast({
            text: err,
            type: 'fail',
            idValue: "remoteTask"
          });
        });
      },
      updateDom() {
        this.$forceUpdate();
      },
    }
  }
</script>

<style>
  .ch-status {
    text-align: center;
    position: absolute;
    left: 72.4%;
  }

  .not-ch-status {
    text-align: center;
    position: absolute;
    left: 71.9%;
  }

  .pu-status {
    text-align: center;
    position: absolute;
    left: 71.5%;
  }

  .status-div {
    width: 110%;
    vertical-align: middle;
    text-align: left;

  }

  #tag-copy {
    display: none;
  }

  .status-error,
  .status-hover {
    position: absolute;
    z-index: 0;
    right: 7.6% !important;
  }

  .status-cerror,
  .status-chover {
    position: absolute;
    z-index: 0;
    right: 8.5% !important;
  }

  .status-not-hover {
    position: absolute;
    z-index: 0;
    right: 16.5%;
  }

  .status-not-chover {
    position: absolute;
    z-index: 0;
    right: 16.5%
  }

  .status-perror,
  .status-phover {
    position: absolute;
    z-index: 0;
    right: 8.6% !important;
  }

  .status-not-phover {
    position: absolute;
    z-index: 0;
    right: 16.5%
  }

  .remote-task-up {
    height: 90px;
    /*no*/
    width: 96%;
    float: left;
    background-color: #f2f7fe;
    padding: 0% 2% 0% 2%;
    position: relative;
    /* 	border-bottom: 0.2px solid #5166BD; */
  }

  .remote-task-body {
    float: left;
    width: 100%;
    height: calc(100% - 120px);
    /*no*/
    box-sizing: border-box;
    padding: 0% 2% 0% 2%;
  }

  .remote-task-body::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 8px;
    /*no*/
    background-color: #fff;
    position: absolute;
    z-index: 700;
  }

  .remote-task-body::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
    position: absolute;
    z-index: 200;
  }

  .remote-task-table {
    width: 100%;
    height: 96%;
    position: relative;
  }

  .remote-task-table-head {
    width: 100%;
    box-sizing: border-box;
  }

  .remote-pointer {
    cursor: pointer;
  }

  #tasktableBox {
    width: 100%;
    height: 100%;
    background: #fff;
    border: 1px solid #cdddf5;
    /*no*/
    border-top: none;
    /*no*/
    position: relative;

  }

  #tasktableBox-head {
    width: 100%;
    height: 100%;
    background: #fff;
    border: 1px solid #cdddf5;
    /*no*/
    border-bottom: none;
    position: relative;
  }

  .remote-task-body .el-loading-mask {
    background-color: #FFFFFF;
    opacity: 1;
    z-index: 0;
    border: 1px solid #cdddf5;
    /*no*/
    border-top: none;
  }

  .remote-task-body .el-loading-spinner .circular {
    height: 50px !important;
    /*no*/
    width: 50px !important;
    /*no*/
  }

  .share-first-td {
    max-width: 400px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #tasktableBox tbody {
    display: block;
    height: 100%;
    overflow-y: auto;
    text-align: left;
    width: 100%;
  }

  .link-list-backgroud {
    background: #e9f5ff;
    height: 40px;
    /*no*/
    display: block;
    position: absolute;

  }

  #tasktableBox .table-tr {
    height: 40px;
    /*no*/
    font-size: 14px;
    /*no*/
    width: 100%;
    position: relative;
    line-height: 40px;
    /*no*/
  }

  #tasktableBox thead,
  #tasktableBox tbody tr {
    width: 100%;
    display: table;
    table-layout: fixed;
    font-size: 14px;
  }

  .table-th {
    height: 40px;
    /*no*/
    color: #a3adbd;
    font-size: 16px;
    /*no*/
    border-bottom: 1px solid #ddd;
    /*no*/
  }

  .tr-position {
    margin-left: 20px;
    /*no*/
    margin-right: 20px !important;
    /*no*/
    float: left;
  }


  .remote-task-table>table tr {
    border-bottom: 1px solid #f0f5fd;
    /*no*/
  }

  .remote-task-table>table {
    border-collapse: collapse ! important;
  }

  .td-options-status {
    width: 10%;
    text-align: left;

    display: table-cell;
  }

  .td-options-message {
    width: 15%;
    text-align: left;
    display: table-cell;
  }

  .td-options {
    width: 10%;
    text-align: left;
    display: table-cell;
  }

  .td-status-block {
    width: 20%;
    position: absolute;
    right: 50%;
  }

  .td-size {
    /*no*/
    width: 15%;
    text-align: left;
    /*no*/
    display: table-cell;
  }

  .td-status {
    width: 17%;
    text-align: left;
    display: table-cell;
  }

  .first-td-style {
    width: 38%;
    padding-left: 20px;
    /*no*/
    box-sizing: border-box;
    text-align: left;
  }

  .first-td {
    position: absolute;
    left: 20px;
    /*no*/
  }

  .remote-name {
    width: 100%;
    height: 30%;
    position: relative;

  }

  .remote-name-task {
    height: 16px;
    /*no*/
    font-size: 16px;
    /*no*/
    font-weight: bold;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .create-task {
    width: 100%;
    height: 70%;
  }

  .create-describe {
    padding-top: 1px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
    width: 100%;
  }


  .create-task-text {
    position: relative;
    margin-left: 5Px;
    /*no*/
    top: 1Px;
    /*no*/
    font-size: 15px;
    /*no*/
    color: #4350a2;
    float: left;
  }

  .create-task-text:hover {
    text-decoration: underline;
  }

  .create-task-button {
    cursor: pointer;
    margin-top: 13px;
    /*no*/
  }

  .create-task-icon {
    float: left;
    margin-top: 2px;
    /*no*/
  }

  .task-icon-position {
    float: right;
    position: relative;
  }

  .task-broom-position {
    position: relative;
    top: 10px;
    /*no*/
    left: -10px;
    /*no*/
  }

  .task-refreshe-position {
    position: relative;
    top: 7px;
    /*no*/

  }

  #tasktableBox thead tr th {
    font-weight: 300;
  }

  #tasktableBox-head thead tr th {
    font-weight: 300;
  }

  .task-refreshe-position:hover:after {
    content: attr(data-title);
    position: absolute;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    left: -35px;
    /*no*/
    top: 19px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 3;
    white-space: nowrap;
    float: left;
  }

  .task-broom-position:hover::after {
    content: attr(data-title);
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 20px;
    /*no*/
    left: -45px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 3;
    white-space: nowrap;
  }

  .task-hover:hover,
  .link-operate:hover {
    color: #5c93ff;
    text-decoration: underline;
    cursor: pointer;
  }

  .noSeeds {
    font-size: 12px;
    /*no*/
  }

  .link-operate {
    white-space: nowrap;
    color: #5c93ff;
  }

  .link-others {
    margin-right: 5px;
    /*no*/
  }

  .parse-failed {
    user-select: none;
    color: #ebf3fe !important
  }

  .parse-failed:hover {
    cursor: default
  }

  /*定义滑块，内阴影及圆角*/
  #tasktableBox tbody::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;
  }

  #tasktableBox tbody::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
  }

  .td-status-run {
    width: 100px;
  }

  .run-no-response {
    margin-left: 10px;
  }

  .remote-tr-hover {
    background: #ebf3fe !important;
  }

  .link-retry-position {
    position: absolute;
    margin-left: 15Px;
    width: 100px;
  }

  .remote-notice {
    text-align: center;
    position: absolute;
    top: 40%;
    bottom: 0;
    margin: 0 auto !important;
    width: 100%;
    height: 20Px;
    font-size: 20Px;
    font-weight: 200;

  }
</style>



// WEBPACK FOOTER //
// src/components/workspace/remote_task.vue